// extracted by mini-css-extract-plugin
module.exports = {"pattern":"styles-module--pattern--1_FN_","hide":"styles-module--hide--1347w"};